import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20composition%20with%20flowing%20gradients%20of%20coral%20red%20and%20warm%20amber%20gold%20tones%2C%20soft%20overlapping%20organic%20shapes%2C%20modern%20minimalist%20design%2C%20ethereal%20atmospheric%20lighting%2C%20smooth%20textures%2C%20digital%20art%20style%2C%20elegant%20and%20sophisticated%20abstract%20background&width=1800&height=900&seq=hero-bg-2024&orientation=landscape"
          alt="福利导航在线观看 - 精选资源一站式导航"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-heading text-3xl md:text-5xl text-background-50 mb-4 max-w-2xl leading-tight">
          精选资源一站式导航
        </h1>
        <p className="text-base md:text-lg text-background-100/80 max-w-xl mb-8 leading-relaxed">
          汇聚全网精选优质资源，分类清晰更新及时，无需下载直接在线观看，畅享流畅体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/yingshi"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            立即探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-8">
          {[
            { value: siteInfo.stats.totalResources, label: '精选资源' },
            { value: siteInfo.stats.dailyVisitors, label: '日活用户' },
            { value: siteInfo.stats.categories, label: '资源分类' },
            { value: siteInfo.stats.satisfaction, label: '用户好评' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs text-background-100/60">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}